import React from 'react'
import {useStateContext} from '../context/StateContext';
import { CgProfile } from 'react-icons/cg';
import { urlFor } from '../lib/client';
import {VisDiv, DateLog} from '../components';
import { isGodMode, isAdmin } from '../lib/userPermissions';

const UserIcon = ({otherUser, bypassCurrentUser, onClick, date="", dateText="", sPicture, style, size=30, name, nameInitials, dateInline}) => {
   
  const {sUser,setSuser} = useStateContext()

    const showTime = () => {
        if(isAdmin(sUser) || isGodMode(sUser) ) return true
        return false
      }
    
    const iconSize  = {width:`${size}px`, height:`${size}px`}
    const enabledStyle = {cursor: "pointer",...style}
    const disabledStyle = {...style }
    
    const USER = otherUser ? otherUser : 
      bypassCurrentUser ? undefined : sUser 
    
    const userPicture = () => {

      if(sPicture){
        return urlFor(sPicture)
      }
      if(USER?.image){
        return urlFor(USER.image)
      }
/*       if (user?.picture){
        return user?.picture
      } */
      return undefined    
    }

  return (
    <>
    <div className='menu-container-profile' onClick={onClick} style={onClick ? enabledStyle : disabledStyle}>
        {userPicture() ?  <img style={{...iconSize}} className='profile-icon' src={userPicture()}></img> :
        <CgProfile style={{...iconSize}} className='profile-icon' />} 
        <div>
          <VisDiv rules={[date]} style={{marginLeft:"3px", fontSize:"12px", fontWeight:"bold"}}><p>{dateText}</p></VisDiv>
          <VisDiv style={{marginLeft:"3px", fontSize:"12px"}} rules={[name, USER]}>{USER?.firstName + " " + USER?.lastName}</VisDiv>
          <VisDiv style={{marginLeft:"3px", fontSize:"12px"}} rules={[nameInitials, USER]}>{USER?.firstName + " " + USER?.lastName}</VisDiv> 
          <VisDiv rules={[date]}> <DateLog date={date} justDate={false} dateAndTime={showTime()}/></VisDiv>
        </div>

    </div>

    </>
  )
}

export default UserIcon

//<img className='profile-icon' src={userPicture()}></img>
